// Common Mental Health Diagnoses with ICD-10 / DSM-5 Codes
// Alphabetically sorted for dropdown usage

export const DIAGNOSES = [
  { name: 'Acute Stress Disorder', code: 'F43.0' },
  { name: 'Adjustment Disorder with Anxiety', code: 'F43.22' },
  { name: 'Adjustment Disorder with Depressed Mood', code: 'F43.21' },
  { name: 'Adjustment Disorder with Mixed Anxiety and Depressed Mood', code: 'F43.23' },
  { name: 'Adjustment Disorder, Unspecified', code: 'F43.20' },
  { name: 'Agoraphobia', code: 'F40.00' },
  { name: 'Alcohol Use Disorder, Mild', code: 'F10.10' },
  { name: 'Alcohol Use Disorder, Moderate', code: 'F10.20' },
  { name: 'Alcohol Use Disorder, Severe', code: 'F10.20' },
  { name: 'Anorexia Nervosa', code: 'F50.01' },
  { name: 'Antisocial Personality Disorder', code: 'F60.2' },
  { name: 'Anxiety Disorder, Unspecified', code: 'F41.9' },
  { name: 'Attention-Deficit/Hyperactivity Disorder (ADHD), Combined Presentation', code: 'F90.2' },
  { name: 'Attention-Deficit/Hyperactivity Disorder (ADHD), Predominantly Inattentive', code: 'F90.0' },
  { name: 'Attention-Deficit/Hyperactivity Disorder (ADHD), Predominantly Hyperactive', code: 'F90.1' },
  { name: 'Autism Spectrum Disorder', code: 'F84.0' },
  { name: 'Avoidant Personality Disorder', code: 'F60.6' },
  { name: 'Binge-Eating Disorder', code: 'F50.81' },
  { name: 'Bipolar I Disorder, Current Episode Depressed', code: 'F31.30' },
  { name: 'Bipolar I Disorder, Current Episode Depressed, Severe', code: 'F31.4' },
  { name: 'Bipolar I Disorder, Current Episode Depressed, in Partial Remission', code: 'F31.5' },
  { name: 'Bipolar I Disorder, Current Episode Manic', code: 'F31.10' },
  { name: 'Bipolar I Disorder, Current Episode Manic, Severe', code: 'F31.13' },
  { name: 'Bipolar I Disorder, Current Episode Manic, Severe with Psychotic Features', code: 'F31.2' },
  { name: 'Bipolar I Disorder, Most Recent Episode Hypomanic', code: 'F31.0' },
  { name: 'Bipolar II Disorder', code: 'F31.81' },
  { name: 'Borderline Personality Disorder', code: 'F60.3' },
  { name: 'Brief Psychotic Disorder', code: 'F23' },
  { name: 'Bulimia Nervosa', code: 'F50.2' },
  { name: 'Cannabis Use Disorder, Mild', code: 'F12.10' },
  { name: 'Cannabis Use Disorder, Moderate to Severe', code: 'F12.20' },
  { name: 'Conduct Disorder, Childhood-Onset Type', code: 'F91.1' },
  { name: 'Conduct Disorder, Adolescent-Onset Type', code: 'F91.2' },
  { name: 'Cyclothymic Disorder', code: 'F34.0' },
  { name: 'Delusional Disorder', code: 'F22' },
  { name: 'Dependent Personality Disorder', code: 'F60.7' },
  { name: 'Depressive Disorder, Unspecified', code: 'F32.9' },
  { name: 'Disruptive Mood Dysregulation Disorder', code: 'F34.81' },
  { name: 'Dissociative Identity Disorder', code: 'F44.81' },
  { name: 'Generalized Anxiety Disorder', code: 'F41.1' },
  { name: 'Histrionic Personality Disorder', code: 'F60.4' },
  { name: 'Hoarding Disorder', code: 'F42.3' },
  { name: 'Illness Anxiety Disorder', code: 'F45.21' },
  { name: 'Insomnia Disorder', code: 'F51.01' },
  { name: 'Intellectual Disability, Mild', code: 'F70' },
  { name: 'Intellectual Disability, Moderate', code: 'F71' },
  { name: 'Intellectual Disability, Severe', code: 'F72' },
  { name: 'Intermittent Explosive Disorder', code: 'F63.81' },
  { name: 'Major Depressive Disorder, Recurrent Episode', code: 'F33.0' },
  { name: 'Major Depressive Disorder, Recurrent Episode, Severe', code: 'F33.2' },
  { name: 'Major Depressive Disorder, Recurrent Episode, Severe with Psychotic Features', code: 'F33.3' },
  { name: 'Major Depressive Disorder, Single Episode', code: 'F32.0' },
  { name: 'Major Depressive Disorder, Severe', code: 'F32.2' },
  { name: 'Narcissistic Personality Disorder', code: 'F60.81' },
  { name: 'Obsessive-Compulsive Disorder (OCD)', code: 'F42.2' },
  { name: 'Obsessive-Compulsive Personality Disorder', code: 'F60.5' },
  { name: 'Opioid Use Disorder, Mild', code: 'F11.10' },
  { name: 'Opioid Use Disorder, Moderate to Severe', code: 'F11.20' },
  { name: 'Oppositional Defiant Disorder', code: 'F91.3' },
  { name: 'Other Specified Schizophrenia Spectrum Disorder', code: 'F28' },
  { name: 'Panic Disorder', code: 'F41.0' },
  { name: 'Paranoid Personality Disorder', code: 'F60.0' },
  { name: 'Persistent Depressive Disorder (Dysthymia)', code: 'F34.1' },
  { name: 'Posttraumatic Stress Disorder (PTSD)', code: 'F43.10' },
  { name: 'Premenstrual Dysphoric Disorder', code: 'F32.81' },
  { name: 'Schizoaffective Disorder, Bipolar Type', code: 'F25.0' },
  { name: 'Schizoaffective Disorder, Depressive Type', code: 'F25.1' },
  { name: 'Schizoid Personality Disorder', code: 'F60.1' },
  { name: 'Schizophrenia', code: 'F20.9' },
  { name: 'Schizophreniform Disorder', code: 'F20.81' },
  { name: 'Schizotypal Personality Disorder', code: 'F21' },
  { name: 'Separation Anxiety Disorder', code: 'F93.0' },
  { name: 'Social Anxiety Disorder (Social Phobia)', code: 'F40.10' },
  { name: 'Somatic Symptom Disorder', code: 'F45.1' },
  { name: 'Specific Learning Disorder with Impairment in Reading', code: 'F81.0' },
  { name: 'Specific Learning Disorder with Impairment in Mathematics', code: 'F81.2' },
  { name: 'Specific Learning Disorder with Impairment in Written Expression', code: 'F81.81' },
  { name: 'Specific Phobia', code: 'F40.218' },
  { name: 'Stimulant Use Disorder, Mild', code: 'F15.10' },
  { name: 'Stimulant Use Disorder, Moderate to Severe', code: 'F15.20' },
  { name: 'Substance-Induced Depressive Disorder', code: 'F19.94' },
  { name: 'Substance-Induced Psychotic Disorder', code: 'F19.959' },
  { name: 'Tourette Disorder', code: 'F95.2' },
  { name: 'Other Specified Anxiety Disorder', code: 'F41.8' },
  { name: 'Other Specified Depressive Disorder', code: 'F32.89' },
  { name: 'Other Specified Trauma- and Stressor-Related Disorder', code: 'F43.8' },
  { name: 'Unspecified Anxiety Disorder', code: 'F41.9' },
  { name: 'Unspecified Bipolar Disorder', code: 'F31.9' },
  { name: 'Unspecified Depressive Disorder', code: 'F32.9' },
  { name: 'Unspecified Mental Disorder', code: 'F99' },
  { name: 'Unspecified Psychotic Disorder', code: 'F29' },
  { name: 'Unspecified Schizophrenia Spectrum Disorder', code: 'F29' },
  { name: 'Unspecified Trauma- and Stressor-Related Disorder', code: 'F43.9' }
].sort((a, b) => a.name.localeCompare(b.name));


// PRP Adults Referral — restricted diagnosis codes (deduplicated)
const PRP_ADULTS_CODES = new Set([
  'F20.9', 'F21', 'F31.4', 'F31.9', 'F20.81', 'F22',
  'F31.5', 'F31.81', 'F25.0', 'F33.2', 'F31.0', 'F60.3',
  'F25.1', 'F33.3', 'F28', 'F31.13', 'F29', 'F31.2'
]);

export const PRP_ADULTS_DIAGNOSES = DIAGNOSES.filter(d => PRP_ADULTS_CODES.has(d.code));

// Helper to search within PRP Adults diagnoses only
export const searchPRPAdultsDiagnoses = (searchTerm) => {
  if (!searchTerm) return PRP_ADULTS_DIAGNOSES;
  const term = searchTerm.toLowerCase();
  return PRP_ADULTS_DIAGNOSES.filter(d =>
    d.name.toLowerCase().includes(term) ||
    d.code.toLowerCase().includes(term)
  );
};


// Helper function to get code by diagnosis name
export const getDiagnosisCode = (diagnosisName) => {
  const diagnosis = DIAGNOSES.find(d => d.name === diagnosisName);
  return diagnosis ? diagnosis.code : '';
};

// Helper function to search diagnoses (full list)
export const searchDiagnoses = (searchTerm) => {
  if (!searchTerm) return DIAGNOSES;
  const term = searchTerm.toLowerCase();
  return DIAGNOSES.filter(d => 
    d.name.toLowerCase().includes(term) || 
    d.code.toLowerCase().includes(term)
  );
};
